// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlApiAdmin: "http://104.238.125.130:9095/api/v1/",
  urlApiFiona: "http://a2dc827a1bc6847ba87340eee60a0b3b-de80dc79001260f4.elb.us-east-1.amazonaws.com/fionna/fionnaBackOffice/",
  urlApiFionaParking: "http://a2dc827a1bc6847ba87340eee60a0b3b-de80dc79001260f4.elb.us-east-1.amazonaws.com/fionna/fionnaParking/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
